import { useLocation, useNavigate, useParams } from 'react-router-dom';
import DraggableModal from '../../../../common/ant-components/DraggableModal';
import React, { useEffect } from 'react';
import { AntButton } from '../../../../common/ant-components/AntButton';
import { useNavigationHistory } from '../../../../common/navigation-history';
import { returnLinks } from '../../../../common/navigation-history/data';
import { useTransactionContext } from '@/context/TransactionContext';
import { BACK_ROUTES_PATH } from '../modals/data';
import { useDeleteApi } from '@/apiError/apiDelete';

export const ConfirmDelete = (props) => {
  const { yesNo = false, setYesNo, yesRef, noRef } = props;
  const navigate = useNavigate();
  const history = useNavigationHistory();
  const location = useLocation();
  const pathname = location?.pathname;

  const deleteApi = useDeleteApi();

  const { id, ids, issueid } = useParams();
  const param = useParams();

  const deleteURls = {
    '/sales/order/': '/transaction/sale-order',
    '/sales/return/': '/transaction/sale-return',
    '/purchase/return/': '/transaction/purchase-return',
    '/issue/karigar/edit/': '/transaction/issue/karigar',
    '/issue/refine/edit/': '/transaction/issue/refine',
    '/issue/party/edit/': '/transaction/issue/party',
    '/receive/karigar/edit/': '/transaction/receive/karigar',
    '/receive/refine/edit/': '/transaction/receive/refine',
    '/receive/party/edit/': '/transaction/receive/party',
    '/payment/voucher/edit/': '/vouchers/payment',
    '/contra/voucher/edit/': '/vouchers/contra',
    '/journal/voucher/edit/': '/vouchers/journal',
    '/receipt/voucher/edit/': '/vouchers/receipt',
    '/transaction/metal-cash-payment/edit/': '/transaction/metal-cash-payment',
    '/transaction/metal-cash-receipt/edit/': '/transaction/metal-cash-receipt',
    '/opening/stock/edit/': '/transaction/opening-stock',
    '/purchase/': '/transaction/purchase',
    '/sales/': '/transaction/sale',
  };

  const url = Object.keys(deleteURls).find((deleteUrl) => {
    const regex = new RegExp(`^${deleteUrl.replace(/\//g, '\\/')}`);
    return regex.test(location?.pathname);
  });

  const exclude = [
    '/codewindow',
    '/sales/return/code/window',
    '/purchase/return/code/window',
    '/transaction/sales/create/',
    '/transaction/sales/edit/',
    '/ledger-details/reports/',
    '/stock/detail/report/',
    '/stock/ledger/report/',
    '/ledger/reports/',
    '/stock-summary/reports/',
  ];

  const isExcluded = exclude?.some((path) =>
    location?.pathname?.startsWith(path),
  );

  const state = location?.state || null;

  const isRedirectPath = BACK_ROUTES_PATH?.find(
    (item) => item?.route === pathname || pathname.startsWith(item.route),
  )?.route_to_redirect;

  const { ledgerDetails, stockDetails, setLedgerDetails } =
    useTransactionContext();

  // const stateData = ledgerDetails || stockDetails || state;

  const stateData = ledgerDetails
    ? ledgerDetails
    : stockDetails?.code
      ? stockDetails
      : state;

  const target = isExcluded
    ? null
    : [...history]
        .reverse()
        .find(
          (path, index) =>
            index === 1 &&
            returnLinks?.some((prefix) => path.startsWith(prefix)),
        );

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.code === 'ArrowRight') {
        e.preventDefault();
        requestAnimationFrame(() => {
          noRef?.current?.focus();
        });
      }
      if (e.code === 'ArrowLeft') {
        e.preventDefault();
        requestAnimationFrame(() => {
          yesRef?.current?.focus();
        });
      }
      // if (e.code === 'Escape') {
      //   e.preventDefault();
      //   target
      //     ? navigate(target, {
      //         state: {
      //           ...stateData,
      //         },
      //       })
      //     : isRedirectPath
      //       ? navigate(isRedirectPath, {
      //           state: {
      //             ...stateData,
      //           },
      //         })
      //       : navigate(-1);
      // }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <DraggableModal
      open={yesNo}
      onCancel={() => setYesNo(false)}
      width={400}
      title={'Do you want to delete this voucher?'}
      footer={
        <div className="tw-flex tw-justify-end tw-gap-x-3">
          <div>
            <AntButton
              ref={yesRef}
              onClick={async () => {
                await deleteApi.mutateAsync(
                  `${deleteURls[url]}/${id || ids || issueid}/`,
                );
                target
                  ? navigate(target, {
                      state: {
                        ...stateData,
                      },
                    })
                  : isRedirectPath
                    ? navigate(isRedirectPath, {
                        state: {
                          ...stateData,
                        },
                      })
                    : navigate(-1);
              }}
            >
              Yes
            </AntButton>
          </div>
          <div>
            <AntButton
              color="red"
              ref={noRef}
              onClick={() => {
                setYesNo(false);
              }}
            >
              Cancel
            </AntButton>
          </div>
        </div>
      }
      children={undefined}
      setOpen={function (e) {
        throw new Error('Function not implemented.');
      }}
    />
  );
};
